module.exports = __webpack_public_path__ + "static/media/EHMadsen_web.b661b579.jpg";